// @flow
export const ENTITY_NAME = {
  ACTION: 'Action',
  COLLECTION: 'Collection',
  ROUTE: 'Route',
  DRIVER: 'Driver',
};
